<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-question">
            <div class="question-header">
              <h3 class="title">
                <div class="item">
                  1:1 문의
                </div>
              </h3>
              <div class="question" @click="moveMenu('CS103')" v-if="userInfo.userRole === 'ClubManager'">
                <button>
                  문의하기
                </button>
              </div>
            </div>
            <div class="question-search" v-if="userInfo.userRole !== undefined && userInfo.userRole !== 'ClubManager'">
              <div class="body">
                <div class="form">
                  <div class="select">
                    <div class="formSelect" ref="select01" @click="openSelect01">
                      <div class="formSelectList">
                        <input type="text" :value="findTypeKey(selectType)" placeholder="유형" readonly />
                      </div>
                      <div class="formSelectPopup select01">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="검색어를 입력하세요."/>
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="searchType in searchTypeList" :key="searchType.key">
                                      <label>
                                        <input type="radio" v-model="selectType" :value="searchType.key" @change="search"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{ searchType.value }}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="select writer">
                    <div class="formSelect" ref="select02">
                      <div class="formSelectList" @click="openSelect02">
                        <input type="text" :value="select02Value" placeholder="작성자" readonly />
                      </div>
                      <div class="formSelectPopup typeMulti typeSearch select02">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="검색어를 입력하세요." v-model="searchValue" v-on:keyup="changeSearchValue"  />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li>
                                      <label>
                                        <input type="radio" />
                                        <input type="checkbox" @click="selectAll" :checked="allSelected"/>
                                        <i></i>
                                        <span>전체선택</span>
                                      </label>
                                    </li>
                                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                      <label>
                                        <input type="radio" />
                                        <input type="checkbox" v-model="selectedClubList" :value="clubInfo.ccode"/>
                                        <i></i>
                                        <span>{{ clubInfo.club_name }}({{ clubInfo.ccode }})</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel" @click="cancelSelect02">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm" @click="confirmSelect02">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="input">
                    <input type="text" placeholder="검색어를 입력하세요" v-model="searchWord" @keyup.enter="search"/>
                  </div>
                  <div class="search">
                    <button @click="search">
                      검색
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="question-check">
              <div class="body">
                <label>
                  <input type="checkbox" v-model="searchStatus" @change="search"/>
                  <i></i>
                  확인중 게시물만 보기
                </label>
              </div>
            </div>
            <div class="question-board">
              <div class="header">
                <ul class="list">
                  <li class="object">
                    답변 여부
                  </li>
                  <li class="type">
                    유형
                  </li>
                  <li class="title">
                    제목
                  </li>
                  <li class="writer">
                    작성자
                  </li>
                  <li class="date">
                    작성일
                  </li>
                </ul>
              </div>
              <!-- 데이터 없을때(Class) : none -->
              <div class="body" :class="inquireList !== null && inquireList.length === 0 ? 'none' : ''">
                <ul class="list">
                  <!-- 유형 버전(Class) : typeVersion / 유형 이벤트(Class) : typeEvent / 유형 확인중(Class) : typeChecking -->
                  <li :class="typeClass(inquire.type)" v-for="inquire in inquireList" @click="moveMenu(`/CS102?inquire_id=${inquire.inquire_id}`)" :key="inquire.inquire_id">
                    <div class="object">
                      <div class="item">
                        {{ isAnswered(inquire.status) ? '답변완료' : '확인중' }}
                      </div>
                    </div>
                    <div class="type">
                      <div class="item">
                        {{ findTypeKey(inquire.type) }}
                      </div>
                    </div>
                    <div class="title">
                      <div class="item">
                        {{ inquire.title }}
                      </div>
                    </div>
                    <div class="writer">
                      <div class="item">
                        {{ inquire.user_name }} ({{ inquire.user_id }})
                      </div>
                    </div>
                    <div class="date">
                      <div class="item">
                        {{ inquire.isrt_dt.substring(0,10) }}
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="none">
                  등록된 게시물이 없습니다.
                </div>
              </div>
            </div>
            <div class="question-page">
              <div class="paging" :class="pageClass">
                <div class="prev" @click="prevPage">
                  <div class="item">
                    이전
                  </div>
                </div>
                <ul class="number" v-for="index in pageArray" :key="index">
                  <!-- 활성 : active -->
                  <li :class="index == pageNo ? 'active': ''" @click="getPage(index)">
                    {{ index }}
                  </li>
                </ul>
                <div class="next" @click="nextPage">
                  <div class="item">
                    다음
                  </div>
                </div>
              </div>
            </div>
            <div class="question-more">
              <div class="more" v-if="pageNo < inquireCnt/pageSize" @click="morePage">
                더보기
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {clubInfoService, csService, userService} from '../../router'

export default {
  name: 'CS101',
  data () {
    return {
      userInfo: {},
      pageNo: 1,
      pageIndex: 0,
      pageSize: 10,
      pageBufferRight: 0,
      pageBufferLeft: 0,
      pageBuffer: 5,
      inquireCnt: 0,
      inquireList: null,
      clubInfoList: [],
      selectClubInfoList: [],
      selectedClubList: [],
      currentClubList: [],
      searchValue: '',
      selectType: '',
      searchWord: '',
      searchStatus: false,
      searchParams: {
        pageNo: 1,
        pageSize: 10,
        searchStatus: false,
        selectType: 'all',
        selectedClubList: [],
        searchWord: ''
      },
      searchTypeList: [
        {
          key: 'all',
          value: '전체'
        },
        {
          key: 'service',
          value: '서비스'
        },
        {
          key: 'event',
          value: '이벤트'
        },
        {
          key: 'update',
          value: '업데이트'
        }
      ]
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
    window.addEventListener('resize', this.resizeEvt)
  },
  mounted: function () {
    clubInfoService.getClubInfoList('active').then(response => {
      this.clubInfoList = response.data.clubInfoList
      this.selectClubInfoList = response.data.clubInfoList
    }).catch(error => {
      console.log('getClubInfoListByStatusActive.err.===>', error)
    })
    this.setData()
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      if (this.allSelected) this.searchParams.selectedClubList = []
      csService.getInquireList(this.searchParams.pageNo, this.searchParams.pageSize, this.searchParams.searchStatus, this.searchParams.selectType, this.searchParams.selectedClubList, this.searchParams.searchWord).then(response => {
        this.inquireCnt = response.data.inquireCnt
        this.inquireList = response.data.inquireList
      })
    },
    search: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.searchParams = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        searchStatus: this.searchStatus,
        selectType: this.selectType,
        selectedClubList: this.selectedClubList,
        searchWord: this.searchWord
      }
      this.setData()
    },
    getPage: function (index) {
      this.pageNo = index
      this.searchParams.pageNo = index
      this.setData()
    },
    morePage: function () {
      this.pageNo += 1
      this.searchParams.pageNo = this.pageNo
      csService.getInquireList(this.searchParams.pageNo, this.searchParams.pageSize, this.searchParams.searchStatus, this.searchParams.selectType, this.searchParams.selectedClubList, this.searchParams.searchWord).then(response => {
        this.inquireCnt = response.data.inquireCnt
        this.inquireList = this.inquireList.concat(response.data.inquireList)
      })
    },
    nextPage: function () {
      if (this.pageIndex >= this.pageIndexMax) return
      this.pageIndex++
      this.getPage(this.pageArray[0])
    },
    prevPage: function () {
      if (this.pageIndex <= 0) return
      this.pageIndex--
      this.getPage(this.pageArray[this.pageArray.length - 1])
    },
    isAnswered: function (status) {
      return status === 'completed'
    },
    typeClass: function (type) {
      let classType = ''
      switch (type) {
        case 'service':
          classType = 'typeChecking'
          break
        case 'update':
          classType = 'typeVersion'
          break
        case 'event':
          classType = 'typeEvent'
          break
      }
      return classType
    },
    selectAll: function () {
      if (this.allSelected) {
        this.selectedClubList = []
      } else {
        this.selectedClubList = this.clubInfoList.map(it => it.ccode)
      }
    },
    findTypeKey: function (searchType) {
      if (this.searchTypeList.find(it => it.key === searchType) !== undefined) {
        return this.searchTypeList.find(it => it.key === searchType).value
      } else {
        return ''
      }
    },
    openSelect02: function () {
      if (document.querySelector('body.type-content.select02Active') !== null) {
        this.cancelSelect02()
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select02Active`)
        document.querySelector('body.type-content').classList.add('multiSelect')
      }
    },
    cancelSelect02: function () {
      this.closeSelectAll()
    },
    confirmSelect02: function () {
      this.currentClubList = this.selectedClubList
      this.closeSelectAll()
      this.search()
    },
    closeSelectAll: function () {
      document.querySelector('body.type-content').classList.remove(`select01Active`)
      document.querySelector('body.type-content').classList.remove(`select02Active`)
      document.querySelector('body.type-content').classList.remove(`select03Active`)
      document.querySelector('body.type-content').classList.remove(`select04Active`)
      document.querySelector('body.type-content').classList.remove(`multiSelect`)
      this.tooltipActive = false
      this.selectedClubList = this.currentClubList
    },
    resetSearchParams: function () {
      this.pageNo = 1
      this.pageIndex = 0
      this.selectType = ''
      this.selectedClubList = []
      this.currentClubList = []
      this.searchWord = ''
      this.searchParams = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        searchStatus: this.searchStatus,
        selectType: this.selectType,
        selectedClubList: this.selectedClubList,
        searchWord: this.searchWord
      }
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.resetSearchParams()
          this.setData()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.resetSearchParams()
          this.setData()
        }
      }
    }
  },
  computed: {
    pageArray: function () {
      if (this.inquireCnt <= 0) return [1]
      let pageMax = Math.floor((this.inquireCnt - 1) / this.pageSize) + 1
      let arr = []
      for (let i = 1; i <= this.pageBuffer; i++) {
        let j = this.pageIndex * this.pageBuffer + i
        if (j > pageMax) break
        arr.push(j)
      }
      return arr
    },
    pageIndexMax: function () {
      return Math.floor((this.inquireCnt - 1) / (this.pageSize * this.pageBuffer))
    },
    pageClass: function () {
      return {
        nextActive: this.pageIndex < this.pageIndexMax,
        prevActive: this.pageIndex > 0
      }
    },
    select02Value: function () {
      if (!this.selectedClubList.length) return ''
      if (this.selectedClubList.length === this.clubInfoList.length) return '전체'
      return `골프클럽(${this.selectedClubList.length})`
    },
    allSelected: function () {
      return this.selectedClubList.length === this.clubInfoList.length
    }
  },
  watch: {
    pageIndex: function (val) {
      this.pageIndex = val < 0 ? 0 : val > this.pageIndexMax ? this.pageIndexMax : val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cs/CS101.vue